import resume from '../assets/pdf/resume.pdf'

export const headerData = {
    name: 'Shikher Mishra',
    title: "SE II",
    desciption:"Life may be a meandering path but don't worry about it, rather enjoy it. It is about the journey, not the destination so explore all that comes your way, learn and grow from it, for this journey only happens once.",
    image: 'https://avatars.githubusercontent.com/u/47721408?v=4',
    resumePdf: resume
}
